"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YarnVersion = void 0;
exports.YarnVersion = typeof YARN_VERSION !== `undefined`
    ? YARN_VERSION
    : null;
